const noop = (): void => {};
export default noop;
